exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".license[data-v-d1d006b0] {\n  margin-top: 24px;\n  font-size: 0.9rem;\n}\n.how-to-quote[data-v-d1d006b0] {\n  margin-top: 12px;\n  font-size: 0.9rem;\n}\n@media print {\n.download-dialog[data-v-d1d006b0] {\n    display: none;\n}\n}", ""]);

// exports
